import axios from "axios";

export const getExchangeRate = () =>
  axios.get("https://abmts.csx.com.kh/api/public/dba/mts/exchange-rate");
